import state from './moduleAuthState.js'
import actions from './moduleAuthActions.js'
import getters from './moduleAuthGetters.js'
import mutations from './moduleAuthMutations.js'

export default {
	namespaced: true,

    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
}
